import EffectAmount from '@/roc/effects/EffectAmount';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
class ProductionOutput extends EffectAmount {
    __output;
    __description;
    __items;
    constructor(calc, amount, output = 0, description = null, items = null) {
        super(calc, amount);
        this.__output = output;
        this.__description = description;
        this.__items = items;
    }
    get output() {
        return this.__output;
    }
    get description() {
        return this.__description;
    }
    get items() {
        return this.__items;
    }
    isChest() {
        return this.__output === ProductionOutputType.CHEST;
    }
    format(amount) {
        if (typeof amount === 'number') {
            if (amount.toFixed(2).endsWith('.00') || amount.toFixed(1).endsWith('.0')) {
                amount = amount.toFixed(0);
            }
        }
        const r = this.toString();
        if (amount === 1) {
            return amount + ' ' + r;
        }
        if (!r.endsWith('s') && !['food'].includes(r)) {
            return amount + ' ' + r + 's';
        }
        return amount + ' ' + r;
    }
    withAmount(amount) {
        return new ProductionOutput(amount.__calc, amount.__amount, this.__output, this.__description, this.__items);
    }
    withOutput(output) {
        return new ProductionOutput(this.__calc, this.__amount, output, this.__description, this.__items);
    }
    withDescription(description) {
        return new ProductionOutput(this.__calc, this.__amount, this.__output, description, this.__items);
    }
    withItems(items) {
        return new ProductionOutput(this.__calc, this.__amount, this.__output, this.__description, items);
    }
    toString() {
        switch (this.__output) {
            case ProductionOutputType.GOLD:
                return 'coin';
            case ProductionOutputType.FOOD:
                return 'food';
            case ProductionOutputType.CURRENT_ERA_PRIMARY_GOODS:
                return 'current era primary goods';
            case ProductionOutputType.CURRENT_ERA_SECONDARY_GOODS:
                return 'current era secondary goods';
            case ProductionOutputType.CURRENT_ERA_TERTIARY_GOODS:
                return 'current era tertiary goods';
            case ProductionOutputType.PREVIOUS_ERA_PRIMARY_GOODS:
                return 'previous era primary goods';
            case ProductionOutputType.PREVIOUS_ERA_SECONDARY_GOODS:
                return 'previous era secondary goods';
            case ProductionOutputType.PREVIOUS_ERA_TERTIARY_GOODS:
                return 'previous era tertiary goods';
            case ProductionOutputType.RESEARCH_POINTS:
                return 'research point';
            case ProductionOutputType.WONDER_HELP_REQUEST:
                return 'wonder help request';
            case ProductionOutputType.WONDER_HELP_ACTION:
                return 'wonder help action';
            case ProductionOutputType.CHEST:
                return 'chest';
            case ProductionOutputType.GEARS:
                return 'gears';
            case ProductionOutputType.RANDOM_BARRACKS_REFILL:
                return 'random barracks refill';
            case ProductionOutputType.BARRACKS_REFILL_SELECTION_KIT:
                return 'barracks refill selection kit';
            case ProductionOutputType.RANDOM_MERCENARY_COMMANDER:
                return 'random mercenary commander';
            case ProductionOutputType.MERCENARY_COMMANDER_SELECTION_KIT:
                return 'mercenary commander selection kit';
            case ProductionOutputType.ALL_PREVIOUS_ERA_GOODS:
                return 'previous era goods';
            case ProductionOutputType.ALL_CURRENT_ERA_GOODS:
                return 'current era goods';
            case ProductionOutputType.NEGOTIATION_JOKER:
                return 'negotiation joker';
            case ProductionOutputType.EVENT_PUZZLE_PIECE:
                return 'event puzzle piece';
            case ProductionOutputType.SQUAD_HEALING_ITEM:
                return 'squad healing item';
            case ProductionOutputType.COMPLETE_SQUAD_HEALING_ITEM:
                return 'complete squad healing item';
            case ProductionOutputType.REGULAR_PUZZLE_PIECE:
                return 'regular puzzle piece';
            case ProductionOutputType.RANDOM_PREVIOUS_ERA_GOODS:
                return 'random previous era goods';
            case ProductionOutputType.RANDOM_CURRENT_ERA_GOODS:
                return 'random current era goods';
            case ProductionOutputType.TREASURE_HUNT_ATTEMPT:
                return 'treasure hunt attempt';
            case ProductionOutputType.RANDOM_GOODS:
                return 'random goods';
            case ProductionOutputType.EVENT_CURRENCY:
                return 'event currency';
        }
        throw new Error('Unknown output type: ' + this.__output);
    }
}
export default ProductionOutput;
